module.exports = __webpack_public_path__ + "static/media/cwu_a_legionella.e7f66bf2.svg";